import { createContext, useContext } from 'react';

/**
 * Current search keyword, shared from `AppSelectContent` down to its items and
 * footer/bridge slots. Provided by `AppSelectContent`; do not use directly —
 * read it via `useAppSelectSearch`.
 */
export const SearchContext = createContext('');

/**
 * Read the current search keyword inside an `AppSelectContent`. Useful for
 * footer slots that render an inline "+ Create '{search}'" action, or for
 * `SearchBridge` to lift the keyword out to a parent for server-side search.
 */
export function useAppSelectSearch(): string {
  return useContext(SearchContext);
}
